import { render, staticRenderFns } from "./SalesOrderStatusArchived.vue?vue&type=template&id=62c00c20&"
import script from "./SalesOrderStatusArchived.vue?vue&type=script&lang=js&"
export * from "./SalesOrderStatusArchived.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderStatusArchived.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports